import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

function animateMedia() {

    // console.log('animateMedia loaded');

    const mediaContainers = document.querySelectorAll('.animate__media');

    mediaContainers.forEach(container => {

        const img = container.querySelector('img');
        const video = container.querySelector('video');
        const element = img || video;

        if (!element) return;

        const setContainerHeight = () => {

            // Obtener dimensiones naturales
            const naturalWidth = element.naturalWidth || element.videoWidth || element.offsetWidth;
            const naturalHeight = element.naturalHeight || element.videoHeight || element.offsetHeight;
            
            if (!naturalWidth || !naturalHeight) return;

            // Calcular ratio de aspecto
            const aspectRatio = naturalHeight / naturalWidth;
            
            // Obtener ancho actual del contenedor
            const containerWidth = container.offsetWidth;
            
            // Calcular altura basada en el ratio de aspecto
            const calculatedHeight = containerWidth * aspectRatio;
            
            // Establecer altura en el contenedor
            container.style.height = `${calculatedHeight}px`;
            
            // console.log('Container height set:', calculatedHeight);
        };

        // Para imágenes
        if (img) {
            if (img.complete) {
                setContainerHeight();
            } else {
                img.addEventListener('load', setContainerHeight);
            }
        }

        // Para videos
        if (video) {
            if (video.readyState >= 1) {
                setContainerHeight();
            } else {
                video.addEventListener('loadedmetadata', setContainerHeight);
            }
        }

        // Asegurar overflow hidden en el contenedor
        container.style.overflow = 'hidden';

        gsap.set(element, { yPercent: 15, });  // Posición inicial más sutil

        // Aplicar efecto parallax con GSAP ScrollTrigger
        const parallaxTween = gsap.fromTo(element, {
            yPercent: 15,  // Posición inicial más sutil
        }, {
            yPercent: -15,  // Movimiento más sutil
            ease: "none",
            scrollTrigger: {
                trigger: container,
                start: "top bottom",
                end: "bottom top",
                scrub: true,
                invalidateOnRefresh: true
            }
        });

        // Guardar referencia del tween en el contenedor
        container._parallaxTween = parallaxTween;
        
        // Guardar referencia del ScrollTrigger en el contenedor
        container._parallaxScrollTrigger = parallaxTween.scrollTrigger;

    });

}

export default animateMedia;